import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface PublicSettingsTheme {
  shop_name?: string
  brand_primary_color?: string | null
}

export interface StoreTheme {
  isDarkTheme: boolean
  isMayParfum: boolean
  isKlodchik: boolean
  shopName: string
  bgPageClass: string
  bgCardClass: string
  textPrimaryClass: string
  textSecondaryClass: string
  borderClass: string
  accentBtnClass: string
  accentBadgeClass: string
  accentTextClass: string
}

export function useStoreTheme(): StoreTheme {
  const { data: settings } = useQuery<PublicSettingsTheme>({
    queryKey: ['public-settings'],
    queryFn: () => api.get('/settings'),
    staleTime: 300_000,
  })

  const rawName = settings?.shop_name ?? ''
  const shopName = rawName.toLowerCase().replace(/\s+/g, '')
  const isMayParfum = shopName.includes('mayparfum')
  const isKlodchik = shopName.includes('klodchik') || shopName.includes('заточ') || shopName.includes('sharp')

  if (isMayParfum) {
    return {
      isDarkTheme: true,
      isMayParfum: true,
      isKlodchik: false,
      shopName: rawName,
      bgPageClass: 'bg-[#1a202c]',
      bgCardClass: 'bg-[#242c38]',
      textPrimaryClass: 'text-[#f8f3ea]',
      textSecondaryClass: 'text-slate-300',
      borderClass: 'border-[#2d3748]',
      accentBtnClass: 'bg-[#c9a24b] text-[#17120f] font-bold hover:bg-[#d8b25c]',
      accentBadgeClass: 'bg-amber-500/10 text-amber-300 border border-amber-500/30',
      accentTextClass: 'text-amber-400',
    }
  }

  if (isKlodchik) {
    return {
      isDarkTheme: true,
      isMayParfum: false,
      isKlodchik: true,
      shopName: rawName,
      bgPageClass: 'bg-[#15181c]',
      bgCardClass: 'bg-[#1f242d]',
      textPrimaryClass: 'text-slate-100',
      textSecondaryClass: 'text-slate-400',
      borderClass: 'border-[#2d3748]',
      accentBtnClass: 'bg-amber-500 text-slate-950 font-bold hover:bg-amber-400',
      accentBadgeClass: 'bg-amber-500/10 text-amber-300 border border-amber-500/30',
      accentTextClass: 'text-amber-400',
    }
  }

  return {
    isDarkTheme: false,
    isMayParfum: false,
    isKlodchik: false,
    shopName: rawName,
    bgPageClass: 'bg-slate-50/60',
    bgCardClass: 'bg-white',
    textPrimaryClass: 'text-slate-900',
    textSecondaryClass: 'text-slate-600',
    borderClass: 'border-slate-200/80',
    accentBtnClass: 'bg-brand-600 text-white font-semibold hover:bg-brand-700',
    accentBadgeClass: 'bg-brand-50 text-brand-700 border border-brand-200/80',
    accentTextClass: 'text-brand-600',
  }
}
